/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { GetToken200, GetTokenPathParameters } from "../schemas";

import { customInstance } from "../../config/mutator";

export const getBeeToken = () => {
  /**
   * Exchanges client credentials for a BEE plugin login token for the given BEE type (lp or email).
   * @summary Get a BEE plugin auth token
   */
  const getToken = ({ clientId, type }: GetTokenPathParameters) => {
    return customInstance<GetToken200>({
      url: `/api/bee/clients/${clientId}/token/${type}`,
      method: "GET",
    });
  };
  return { getToken };
};
export type GetTokenResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeToken>["getToken"]>>
>;
